import { render, staticRenderFns } from "./MainNotiList.vue?vue&type=template&id=8c5630e2&scoped=true&"
import script from "./MainNotiList.vue?vue&type=script&lang=js&"
export * from "./MainNotiList.vue?vue&type=script&lang=js&"
import style0 from "./MainNotiList.vue?vue&type=style&index=0&id=8c5630e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c5630e2",
  null
  
)

export default component.exports